import axios from 'axios';

// ACTION TYPES
const name = 'data';
export const actionTypes = {
  SET_LATEST_DATA: `${name}:set_latest_data`,
  SET_HISTORY_DATA: `${name}:set_history_data`,
};

// ACTIONS
export function loadLatestData(email) {
  return (dispatch, getState) => {
    const ticker = getState().params.ticker;
    console.log(`refreshing ${ticker}`);

    let params = `ticker=${ticker}`;
    if(email) {
      params = params + `&email=${email}`;
      if (window.digitalData) {
        const e = {
          "eventName": "eNAV realtime",
          "eventCategory": "etf",
          "eventAction": "eNAV realtime",
          "eventLabel": ticker.toLowerCase(),
          "type": "CustomTagEvent"
        };
        window.digitalData.newEvent(e);
      }
    }

    const request = {
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/enav/latest/?${params}`,
    };
    return axios(request)
      .then((response) => {
        dispatch({ type: actionTypes.SET_LATEST_DATA, value: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function loadHistoryData() {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/enav/history/?ticker=${getState().params.ticker}`,
    };
    return axios(request)
      .then((response) => {
        dispatch({ type: actionTypes.SET_HISTORY_DATA, value: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/data.js